module.exports = __webpack_public_path__ + "static/media/vegan.1b054e0f.png";